export enum CompareRoutePath {
  DetailsPath = 'details',
  BomPath = 'bom',
  ComparisonSummaryPath = 'comparison-summary',
}
